import { pick } from 'ramda';
import { useMemo } from 'react';
import { useAppSelector } from 'js/store/hooks';
import { useOnClose } from 'js/components/common/PopupManager/hooks';
import { useShowNotification } from 'js/components/common/Notifications';

import { getButtons } from './helpers';
import { useGetURLs } from '../useGetURLs';
import { useGetSubmitAdvancedDialog } from '../useGetSubmitAdvancedDialog';

export const useGetButtons = (data) => {
    const getURLs = useGetURLs();
    const {
        games,
        cashierUrlTemplates
    } = useAppSelector(pick(['games', 'cashierUrlTemplates']));
    const showNotification = useShowNotification({
        iconType: 'error',
        tKey: 'playtech.mobile.system.toast.actionFailed'
    });
    const onClose = useOnClose();
    const submitAdvancedDialog = useGetSubmitAdvancedDialog(data);

    return useMemo(() => getButtons({
        data,
        onClose,
        submitAdvancedDialog,
        showNotification,
        games,
        urlTypeList: cashierUrlTemplates,
        getURLs
    }), [
        data, onClose, submitAdvancedDialog,
        showNotification, games, cashierUrlTemplates, getURLs
    ]);
};
